import type WaDropdownItem from "@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js";
import type { WaSelectEvent } from "@awesome.me/webawesome/dist/events/select.js";
import { Controller } from "@hotwired/stimulus";

export default class SplitButtonController extends Controller<HTMLElement> {
  static override targets = ["link", "label", "item"];
  static override values = { cookieName: String };
  declare readonly linkTarget: HTMLAnchorElement;
  declare readonly labelTarget: HTMLElement;
  declare readonly itemTargets: WaDropdownItem[];
  declare readonly cookieNameValue: string;
  declare readonly hasCookieNameValue: boolean;

  // wa-dropdown toggles `checked` on a checkbox item before it emits
  // wa-select. When the user selects the checked item again, the item is
  // unchecked here, so `checked` is set on all items.
  select(event: WaSelectEvent): void {
    const selected = event.detail.item as WaDropdownItem;
    for (const item of this.itemTargets) {
      item.checked = item === selected;
    }
    this.linkTarget.href = selected.dataset["href"] ?? "";
    this.labelTarget.textContent = selected.dataset["label"] ?? "";
    if (this.hasCookieNameValue) {
      document.cookie = `${this.cookieNameValue}=${encodeURIComponent(selected.value)}; path=/; max-age=31536000; samesite=lax`;
    }
  }
}
